import React, { useState } from 'react';
import bridge from '@vkontakte/vk-bridge';

function About({ appearance, onBack, onNavigate, onSubscribe }) {
  // Стейт для переключения вкладок: 'about', 'guide', 'referrals'
  const [activeTab, setActiveTab] = useState('about');

  // Цвета в стиле iOS
  const bgColor = appearance === 'dark' ? '#000000' : '#f2f2f7';
  const cardBg = appearance === 'dark' ? '#1c1c1e' : '#ffffff';
  const textColor = appearance === 'dark' ? '#ffffff' : '#000000';
  const mutedText = appearance === 'dark' ? '#8e8e93' : '#86868b';
  const highlightColor = appearance === 'dark' ? '#a8c7fa' : '#4b37ff';

  const handleBlogSubscribe = () => {
  if (bridge.isWebView() && typeof onSubscribe === 'function') {
    onSubscribe();
    return;
  }

  window.open(
    "https://vk.com/free_chat_gpt",
    "_blank",
    "noopener,noreferrer"
  );
};

  // Компонент переключателя вкладок
  const TabButton = ({ id, label }) => {
    const isActive = activeTab === id;
    return (
      <div 
        onClick={() => setActiveTab(id)}
        style={{
          flex: 1,
          textAlign: 'center',
          padding: '8px 4px',
          fontSize: '13px',
          fontWeight: isActive ? 600 : 500,
          color: isActive ? textColor : mutedText,
          backgroundColor: isActive ? (appearance === 'dark' ? '#3a3a3c' : '#ffffff') : 'transparent',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          boxShadow: isActive ? '0 1px 4px rgba(0,0,0,0.1)' : 'none'
        }}
      >
        {label}
      </div>
    );
  };

  return (
    <div style={{ 
      flex: 1, 
      display: 'flex', 
      flexDirection: 'column', 
      backgroundColor: bgColor,
      color: textColor,
      padding: '20px 20px 90px 20px', 
      boxSizing: 'border-box',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch'
    }}>
      
      {/* Заголовок */}
      <h2 style={{ margin: '0 0 20px 0', fontSize: '28px', fontWeight: 700 }}>Справочник</h2>

      {/* Сегментированный контрол (вкладки) */}
      <div style={{ 
        display: 'flex', 
        backgroundColor: appearance === 'dark' ? '#1c1c1e' : '#e3e3e8', 
        padding: '3px', 
        borderRadius: '10px',
        marginBottom: '24px',
        flexShrink: 0
      }}>
        <TabButton id="about" label="О нас" />
        <TabButton id="guide" label="Как устроен бот" />
        <TabButton id="referrals" label="Рефералы" />
      </div>

      {/* СОДЕРЖИМОЕ ВКЛАДОК */}
      <div style={{ flex: 1 }}>

        {/* Вкладка 1: О нас */}
        {activeTab === 'about' && (
          <div style={{ animation: 'fadeIn 0.3s ease' }}>
            <div style={{ textAlign: 'center', marginBottom: '24px', marginTop: '16px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ marginBottom: '16px', color: highlightColor }}>
                {/* Иконка Приветствия (Улыбающийся чат) */}
                <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="10" rx="2"></rect>
                  <circle cx="12" cy="5" r="2"></circle>
                  <path d="M12 7v4"></path>
                  <line x1="8" y1="16" x2="8.01" y2="16"></line>
                  <line x1="16" y1="16" x2="16.01" y2="16"></line>
                </svg>
              </div>
              <h2 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: 700 }}>Free GPT Chat</h2>
              <p style={{ margin: 0, opacity: 0.8, fontSize: '15px', lineHeight: 1.4 }}>
                Ваш умный карманный помощник.
              </p>
            </div>

            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px', marginBottom: '16px', boxShadow: appearance === 'dark' ? 'none' : '0 2px 8px rgba(0,0,0,0.04)' }}>
              <p style={{ margin: '0 0 12px 0', fontSize: '15px', lineHeight: 1.5 }}>
                Мы создали этого бота, чтобы у вас всегда под рукой был мощный инструмент для решения любых задач: от написания эссе и кода до пересказа длинных текстов.
              </p>
              <p style={{ margin: 0, fontSize: '15px', lineHeight: 1.5 }}>
                Бот работает на базе GPT 6 Astra и абсолютно бесплатен благодаря системе токенов и рекламы.
              </p>
            </div>

            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <div style={{ marginBottom: '16px', color: highlightColor }}>
                {/* Иконка Блога (Открытая книга/журнал) */}
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                </svg>
              </div>
              <h3 style={{ margin: '0 0 8px 0', fontSize: '18px' }}>Наш блог</h3>
              <p style={{ margin: '0 0 16px 0', fontSize: '14px', color: mutedText, lineHeight: 1.4 }}>
                Подписка на сообщество даёт увеличение ежедневного лимита <b>до 6 767 токенов</b>! В блоге мы публикуем новости о развитии нашего проекта и кучу интересной информации про ИИ.
              </p>
              <button
                onClick={handleBlogSubscribe}
                style={{ width: '100%', padding: '14px', borderRadius: '12px', border: `1px solid ${highlightColor}`, backgroundColor: 'transparent', color: highlightColor, fontSize: '15px', fontWeight: 600, cursor: 'pointer' }}
              >
                Подписаться
              </button>
            </div>
          </div>
        )}

        {/* Вкладка 2: Гайд (Как устроен бот) */}
        {activeTab === 'guide' && (
          <div style={{ animation: 'fadeIn 0.3s ease', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            
            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '17px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                Память и контекст
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: mutedText, lineHeight: 1.5 }}>
                Бот помнит историю вашего диалога, но в целях оптимизации (чтобы не сжигать ваши токены) <b>хранит только последние 10 сообщений</b> (5 ваших вопросов и 5 ответов). Если вам нужно начать совершенно новую тему — лучше создать новый чат.
              </p>
            </div>

            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '17px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
                Управление чатами
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: mutedText, lineHeight: 1.5 }}>
                Вы можете одновременно вести <b>до 3-х разных диалогов</b>. Переключаться между ними можно в боковом меню. Обратите внимание: при создании 4-го чата, самый старый диалог автоматически удалится.
              </p>
            </div>

            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '17px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                Решение по фото
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: mutedText, lineHeight: 1.5 }}>
                Отправьте фотографию конспекта, графика или математического уравнения, и прикрепите к ней текст с вопросом. Нейросеть распознает текст прямо с картинки.
              </p>
            </div>

            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '17px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="5" width="22" height="14" rx="2" ry="2"></rect><line x1="16" y1="12" x2="16.01" y2="12"></line><line x1="8" y1="12" x2="8.01" y2="12"></line><line x1="12" y1="12" x2="12.01" y2="12"></line></svg>
                Экономика токенов
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: mutedText, lineHeight: 1.5 }}>
                Токены — это "топливо" для нейросети. Они списываются в зависимости от длины вашего вопроса и ответа бота. Если токены кончились, просто посмотрите короткое видео, нажав кнопку прямо в чате, чтобы получить +5000 токенов мгновенно.
              </p>
            </div>

          </div>
        )}

        {/* Вкладка 3: Реферальная система */}
        {activeTab === 'referrals' && (
          <div style={{ animation: 'fadeIn 0.3s ease', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            
            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '17px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                Зачем нужны рефералы?
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: mutedText, lineHeight: 1.5 }}>
                Приглашая друзей в наше приложение, вы навсегда увеличиваете свой базовый лимит токенов. А ваши друзья получают щедрый приветственный бонус. Это выгодно всем!
              </p>
            </div>

            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '17px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
                Уровни программы
              </h3>
              <ul style={{ margin: 0, paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px', color: mutedText, lineHeight: 1.4 }}>
                <li>
                  <b>Новичок (1–3 друга):</b><br/>
                  Друг получает 5 000 токенов. Вы получаете +2 000 токенов к лимиту за каждого.
                </li>
                <li>
                  <b>Интеллектуал (4–13 друзей):</b><br/>
                  Друг получает 6 000 токенов. Вы получаете +2 500 токенов к лимиту и +1 генерацию фото.
                </li>
                <li>
                  <b>Начальник (14+ друзей):</b><br/>
                  Друг получает 7 000 токенов. Вы получаете +3 000 токенов к лимиту и +1 генерацию фото.
                </li>
              </ul>
            </div>

            <div style={{ backgroundColor: cardBg, borderRadius: '16px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 12px 0', fontSize: '17px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={highlightColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                Правила
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: mutedText, lineHeight: 1.5 }}>
                Вы не можете ввести свой собственный код. Код можно ввести только один раз. Друг должен скопировать ваш код из меню "Рефералы" и ввести его у себя.
              </p>
            </div>

          </div>
        )}

      </div>

      {/* Динамическая кнопка возврата/навигации в самом низу */}
      <div style={{ marginTop: '24px', flexShrink: 0 }}>
        <button 
          onClick={activeTab === 'referrals' ? () => onNavigate('referrals') : onBack}
          style={{ width: '100%', padding: '16px', borderRadius: '14px', border: 'none', backgroundColor: highlightColor, color: appearance === 'dark' ? '#000' : '#fff', fontSize: '16px', fontWeight: 600, cursor: 'pointer', transition: 'transform 0.1s' }}
          onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
          onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
        >
          {activeTab === 'referrals' ? 'Перейти в реферальный кабинет' : 'Начать чат'}
        </button>
      </div>

       {/*<div style={{ 
          fontSize: '11px', 
          color: appearance === 'dark' ? '#666' : '#999', 
          textAlign: 'center',
          lineHeight: 1.4,
          padding: '0 10px',
          marginTop: '16px'
        }}>
          Оплата в миниапп производится Голосами ВКонтакте. После активации цифрового товара, подписка возврату и отмене не подлежит.<br/><br/>
          
          Оплачивая подписку, вы соглашаетесь с{' '}
          <a href="https://dev.vk.com/ru/user-agreement" target="_blank" rel="noreferrer" style={{ color: appearance === 'dark' ? '#a8c7fa' : '#4b37ff', textDecoration: 'none' }}>
            Пользовательским соглашением
          </a>{' '}
          и{' '}
          <a href="https://dev.vk.com/ru/privacy-policy" target="_blank" rel="noreferrer" style={{ color: appearance === 'dark' ? '#a8c7fa' : '#4b37ff', textDecoration: 'none' }}>
            Политикой конфиденциальности
          </a>.<br/><br/>

          <b>Информация о продавце:</b><br/>
          Самозанятый Ненько Макар Владиславович<br/>
          ИНН: 121524446992<br/>
          Email: ma.nenko@mail.ru<br/>
          Служба поддержки: <a href="https://vk.com/free_chat_gpt" target="_blank" rel="noreferrer" style={{ color: appearance === 'dark' ? '#a8c7fa' : '#4b37ff', textDecoration: 'none' }}>vk.com/free_chat_gpt</a>
        </div>*/}

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

    </div>
  );
}

export default About;